export const footerItem = () => ({
  show: false,

  toggle() {
    this.show = !this.show;
  },

  onResize() {
    if (window.innerWidth > 768) {
      this.show = true;
    } else if (window.innerWidth <= 768 && this.show) {
      this.show = false;
    }
  },
});
